'use client';
import { ROUTES } from '@/constants/routes';
import { BrowsingHistoryContext } from '@/context/BrowsingHistoryContext';
import { usePathname, useRouter } from 'next/navigation';
import { ReactNode, useEffect, useRef } from 'react';

export const BrowsingHistoryProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const navigationStarted = useRef(false);
  const initialPathname = useRef(pathname);

  const goBack = () => {
    if (navigationStarted.current) {
      router.back();
    } else router.push(ROUTES.home);
  };

  useEffect(() => {
    if (initialPathname.current !== pathname) navigationStarted.current = true;
  }, [pathname]);

  return (
    <BrowsingHistoryContext.Provider
      value={{
        goBack,
      }}>
      {children}
    </BrowsingHistoryContext.Provider>
  );
};
